import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorComponent } from './error.component';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';



@NgModule({
  declarations: [ErrorComponent],
  imports: [
    CommonModule,
    ButtonModule,
  ],
   exports:[ErrorComponent],
})
export class ErrorModule { }
